import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import AccessModalListItem from './ModalListItem';

class AccessModalList extends PureComponent {
  getItem(uuid) {
    const {
      listType,
      groups,
      users,
    } = this.props;

    const items = listType === 'groups' ? groups : users;
    return items.find(i => (i.uuid === uuid));
  }

  render() {
    const {
      listType,
      selectedGroups,
      selectedUsers,
    } = this.props;
    const selectedItems = listType === 'groups' ? selectedGroups : selectedUsers;

    return (
      <div className={`access-${listType}-list users-list`}>
        {Object.keys(selectedItems).map((uuid) => {
          const item = this.getItem(uuid);
          if (!item) {
            return false;
          }
          return (
            <AccessModalListItem
              {...this.props}
              key={uuid}
              item={{
                uuid,
                name: item.name ? item.name : '',
                email: item.email ? item.email : '',
                avatar: item.avatar_url ? item.avatar_url : null,
                count: selectedItems[uuid],
                type: listType === 'groups' ? 'group' : 'user',
                hasAccessToCollectionGroup: true,
              }}
            />
          );
        })}
      </div>
    );
  }
}

AccessModalList.propTypes = {
  listType: PropTypes.string.isRequired,
  groups: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired,
  selectedGroups: PropTypes.object,
  selectedUsers: PropTypes.object,
};

AccessModalList.defaultProps = {
  selectedGroups: {},
  selectedUsers: {},
};

export default AccessModalList;
